<template>
  <button
    :disabled="submitting"
    :type="type"
    class="btn submitting-btn"
    :class="[{ submitting: submitting }, classes]"
    aria-live="polite"
    @click.prevent="$emit('submit-action', $event)"
  >
    <span v-show="showIcon" class="iconfont-loader"></span>
    <span v-if="submitting">{{ submittingLabel }}</span>
    <span v-else>{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    submitting: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'submit',
    },
    submittingLabel: {
      type: String,
      default: '',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    classes: {
      type: String,
      default: '',
    },
  },
}
</script>
